module.exports = __webpack_public_path__ + "img/45-TUTA-BAIA-U-STAMPE-LINO-UNITI-LINO3.4429f4ac.jpg";